theme.footerSection = (function () {
  function footer() {
    // Mobile navigation bar
    const mobileNavigateBar = document.querySelector(
      ".mobile__navigation--bar"
    );
    if (mobileNavigateBar) {
      document.documentElement.style.setProperty(
        "--mobile-navigation-bar-height",
        `${mobileNavigateBar.clientHeight}px`
      );

      window.addEventListener("resize", function () {
        document.documentElement.style.setProperty(
          "--mobile-navigation-bar-height",
          `${mobileNavigateBar.clientHeight}px`
        );
      });
    }

    // Swaym Mobile Footer Collapsible Accordion Menus (excluding Newsletter & About blocks)
    function initFooterAccordion() {
      const titles = document.querySelectorAll(
        '.footer__widget:not(.footer__widget--newsletter):not(.footer__widget--about) .footer__widget_title'
      );
      titles.forEach(title => {
        title.addEventListener('click', (e) => {
          if (window.innerWidth >= 768) return;
          e.preventDefault();
          const widget = title.closest('.footer__widget');
          if (!widget) return;

          const isActive = widget.classList.contains('active');

          // Close sibling collapsible widgets for clean UX
          document.querySelectorAll('.footer__widget:not(.footer__widget--newsletter):not(.footer__widget--about)').forEach(w => {
            w.classList.remove('active');
          });

          if (!isActive) {
            widget.classList.add('active');
          }
        });
      });
    }

    initFooterAccordion();

    window.addEventListener("resize", function () {
      document.querySelectorAll(".footer__widget").forEach(function (item) {
        if (window.innerWidth >= 768) {
          item.classList.remove("active");
          const inner = item.querySelector(".footer__widget_inner");
          if (inner) inner.style.display = "";
        }
      });
    });

    // Swaym Mobile Trust Pillars Discrete Auto-Slider
    function initTrustSlider() {
      const slider = document.querySelector('[data-trust-slider]');
      if (!slider) return;

      const track = slider.querySelector('[data-trust-track]');
      const slides = slider.querySelectorAll('[data-trust-slide]');
      const dots = slider.querySelectorAll('.swaym-trust-bar__dot');
      if (!track || slides.length === 0) return;

      let currentIndex = 0;
      let intervalId = null;
      let startX = 0;
      let currentX = 0;
      let isDragging = false;

      function goToSlide(index) {
        if (window.innerWidth >= 768) {
          track.style.transform = '';
          return;
        }
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        currentIndex = index;

        track.style.transform = `translateX(-${currentIndex * 100}%)`;

        dots.forEach((dot, idx) => {
          if (idx === currentIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      function startAutoSlide() {
        stopAutoSlide();
        if (window.innerWidth < 768) {
          intervalId = setInterval(() => {
            goToSlide(currentIndex + 1);
          }, 3500);
        }
      }

      function stopAutoSlide() {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      }

      // Touch events for mobile swipe
      slider.addEventListener('touchstart', (e) => {
        stopAutoSlide();
        startX = e.touches[0].clientX;
        isDragging = true;
      }, { passive: true });

      slider.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        currentX = e.touches[0].clientX;
      }, { passive: true });

      slider.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;
        const diffX = startX - currentX;
        if (Math.abs(diffX) > 40) {
          if (diffX > 0) {
            goToSlide(currentIndex + 1);
          } else {
            goToSlide(currentIndex - 1);
          }
        }
        startAutoSlide();
      });

      // Dot click events
      dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
          stopAutoSlide();
          goToSlide(idx);
          startAutoSlide();
        });
      });

      window.addEventListener('resize', () => {
        goToSlide(currentIndex);
        if (window.innerWidth >= 768) {
          stopAutoSlide();
        } else if (!intervalId) {
          startAutoSlide();
        }
      });

      startAutoSlide();
    }

    initTrustSlider();
  }
  return footer;
})();
